module.exports = __webpack_public_path__ + "img/HavalKwestani-AfratuZhan.27f6bdfa.jpg";